// src/data/rpaData.js
import seoImg from '../../assets/rpa-web/rpa-web-seo.webp';
import shopImg from '../../assets/rpa-web/rpa-web-online-shop.webp';
import chatImg from '../../assets/rpa-web/rpa-web-chat-function.webp';


const rpaData = {
  title: "Digitale Lösungen für moderne Unternehmen",
  tabs: [
    {
      id: "seo",
      label: "SEO",
      heading: "SEO Optimierung",
      text: `Mit unserer ganzheitlichen SEO-Strategie verhelfen wir Ihrer Website zu Spitzenplätzen in Google & Co. 
Wir analysieren relevante Keywords, optimieren Ihre Inhalte technisch sowie inhaltlich und sorgen durch hochwertigen 
Linkaufbau für nachhaltige Sichtbarkeit. So gewinnen Sie mehr qualifizierte Besucher und steigern Ihre Conversionrate.`,
      image: seoImg,
    },
    {
      id: "shop",
      label: "Online Shop",
      heading: "E‑Commerce & Online‑Shops",
      text: `Wir entwickeln individuelle Online‑Shop‑Lösungen, die Ihre Produkte optimal präsentieren und den gesamten Verkaufsprozess 
optimieren. Von responsivem Design über intuitives UX bis hin zur Integration von Zahl- und Versanddiensten – wir schaffen eine 
Verkaufsplattform, die funktioniert und wächst.`,
      image: shopImg,
    },
    {
      id: "chat",
      label: "Chat Funktion",
      heading: "Intelligente Chat‑Funktion",
      text: `Unsere smarten Chat‑Systeme verbinden automatisierte Bots mit persönlichem Live‑Support. Kunden erhalten schnelle Antworten 
rund um die Uhr, während Ihr Team nur bei komplexeren Anfragen eingreift. Das sorgt für höhere Zufriedenheit, geringere Kosten und 
effizientere Support‑Prozesse.`,
      image: chatImg,
    }
  ],
};

export default rpaData;